<template>
<div class="content-w">
    
    <div id="resultado-busca" class="container">
        <ul class="breadcrumb">
        <li class="breadcrumb-item">
            <router-link :to="{name: 'Home'}">Página Principal</router-link>
        </li>
        <li class="breadcrumb-item">
            <span>Resultado de Busca</span>
        </li>
    </ul>
        <div class="element-wrapper" style="padding-bottom: 1rem !important;">
            <div class="row">
                <div class="col-md-2">
                    <h2>Busca</h2>
                </div>
                <div class="col">
                    <form-busca></form-busca>                    
                </div>
            </div>
        </div>

        <div class="content-i">
            <div class="row">
                <div class="col-md-2">
                    <div class="menu-w filters color-style-transparent">
                        <div class="element-wrapper">
                            <h6 class="element-header">
                            Filtros
                            </h6>
                        </div>
                        <ul class="main-menu">
                            
                            <li class="">
                                <span>Avaliação</span>
                                <a @click="limparAvaliacao" class="limpar-link">
                                  <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                </a>
                                <rate :length="5" v-model="formBusca.rate" @after-rate="buscaByRate"></rate>
                            </li>
                            <li class="nome-filtro">
                                <span>Nome</span>
                                <a @click="limparNome" class="limpar-link">
                                    <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                  
                                </a>
                                <input class="form-control" v-model="formBusca.nomeRede" @keydown="buscaByName" placeholder="Digite o nome" type="search">
                            </li>
                            <li class="">
                                <span>Preço Cartão</span>
                                <a @click="limparPreco" class="limpar-link">
                                  <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                </a>
                                <div class="custom-control custom-radio"
                                  v-for="(limite, index) in filtroPreco" :key="index">
                                    <input class="custom-control-input" type="radio" 
                                      v-model="preco" :value="index" :id="`for${limite.vlInicial}`"
                                      @change="buscaByPreco">
                                    <label v-if="limite.vlFinal >= 0 && limite.vlFinal !== Number.POSITIVE_INFINITY" class="custom-control-label" :for="`for${limite.vlInicial}`">
                                        {{ limite.vlInicial | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 0, masked: false}) }} 
                                        a {{ limite.vlFinal | money }}
                                    </label>
                                    <label v-else class="custom-control-label" :for="`for${limite.vlInicial}`">
                                        {{ limite.vlInicial | money }} em diante
                                    </label>
                                </div>
                            </li>
                            <li class="">
                                <span>Outros</span>
                                <a @click="limparOutros" class="limpar-link">
                                  <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                </a>
                                <div class="custom-control custom-checkbox"
                                    v-for="(item, index) in outrosServicosPorTipo" :key="index">
                                    <input v-model="outroServico[item]" :id="`outroservicos-${index}`" 
                                      type="checkbox" class="custom-control-input" :value="item"
                                        @change="findByServicos">
                                    <label :for="`outroservicos-${index}`" class="custom-control-label">{{ item }}</label>
                                </div>
                            </li>
                        </ul>  
                    </div>
                    <button class="btn btn-primary btn-block mt-1 filter-trigger d-sm-block d-md-none" @click="expand = true">Ver Filtros</button>
                    
                    <div class="filters filters-mobile color-style-transparent">
                        <div class="element-wrapper">
                            <h6 class="element-header">
                            Filtros
                            </h6>
                            
                        </div>
                        <ul class="main-menu">
                            
                            <li class="">
                                <span>Avaliação</span>
                                <a @click="limparAvaliacao" class="limpar-link">
                                  <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                </a>
                                <rate :length="5" v-model="formBusca.rate" @after-rate="buscaByRate"></rate>
                            </li>
                            <li class="nome-filtro">
                                <span>Nome</span>
                                <a @click="limparNome" class="limpar-link">
                                    <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                  
                                </a>
                                <input class="form-control" v-model="formBusca.nomeRede" @keydown="buscaByName" placeholder="Digite o nome" type="search">
                            </li>
                            <li class="">
                                <span>Preço Cartão</span>
                                <a @click="limparPreco" class="limpar-link">
                                  <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                </a>
                                <div class="custom-control custom-radio"
                                  v-for="(limite, index) in filtroPreco" :key="index">
                                    <input class="custom-control-input" type="radio" 
                                      v-model="preco" :value="index" :id="`for${limite.vlInicial}`"
                                      @change="buscaByPreco">
                                    <label v-if="limite.vlFinal >= 0 && limite.vlFinal !== Number.POSITIVE_INFINITY" class="custom-control-label" :for="`for${limite.vlInicial}`">
                                        {{ limite.vlInicial | money({decimal: ',', thousands: '.', prefix: 'R$ ', suffix: '', precision: 0, masked: false}) }} 
                                        a {{ limite.vlFinal | money }}
                                    </label>
                                    <label v-else class="custom-control-label" :for="`for${limite.vlInicial}`">
                                        {{ limite.vlInicial | money }} em diante
                                    </label>
                                </div>
                            </li>
                            <li class="">
                                <span>Outros</span>
                                <a @click="limparOutros" class="limpar-link">
                                  <span>Limpar</span>
                                  <i class="os-icon os-icon-cancel-circle"></i>
                                </a>
                                <div class="custom-control custom-checkbox"
                                    v-for="(item, index) in outrosServicosPorTipo" :key="index">
                                    <input v-model="outroServico[item]" :id="`outroservicos-${index}`" 
                                      type="checkbox" class="custom-control-input" :value="item"
                                        @change="findByServicos">
                                    <label :for="`outroservicos-${index}`" class="custom-control-label">{{ item }}</label>
                                </div>
                            </li>
                        </ul>  
                    </div>
                </div>
                <div class="col">
                    <div v-if="result.totalCount > 0" class="list-controls">
                        <div class="list-info">
                        </div>
                        <div class="list-order">
                           
                            <select v-model="formBusca.ordenacao" name="order" id="order" @change="$store.dispatch('busca')" class="form-control">
                                <option :value="null">Ordenar por:</option>
                                <option value="Prestador">Prestador</option>
                                <option value="Preco">Menor Preço (Dr.Achei Cartão)</option>
                                <option value="MaiorPreco">Maior Preço (Dr.Achei Cartão)</option>
                                <option value="MelhorAvaliacao">Avaliações</option>
                            </select>
                        </div>
                    </div>

                    <div class="text-center mt-2">
                        <paginate
                            v-if="result.pageCount > 1"
                            v-model="page"
                            :page-count="result.pageCount"
                            :click-handler="handlePage"
                            :prev-text="'Anterior'"
                            :next-text="'Próximo'"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :next-link-class="'page-link'"
                            :prev-link-class="'page-link'">
                        </paginate>
                    </div>

                    <busca-item-consultorio :servico="formBusca.tipoPedido" :especialidade="formBusca.especialidade" :unidade="unidade" v-for="unidade in listData" :key="unidade.NomeUnidade"></busca-item-consultorio>

                    <div class="no-results" v-if="!listData || listData.length === 0">
                        <div class="big-error-w">
                           
                            <h2 class="text-muted">Ops, Não encontramos nada</h2>
                            <h4>
                             Refaça a sua busca
                            </h4>
                            
                        </div>
                    </div>
                    <div class="text-center mt-2">
                        <paginate
                            v-if="result.pageCount > 1"
                            v-model="page"
                            :page-count="result.pageCount"
                            :click-handler="handlePage"
                            :prev-text="'Anterior'"
                            :next-text="'Próximo'"
                            :container-class="'pagination'"
                            :page-class="'page-item'"
                            :page-link-class="'page-link'"
                            :next-link-class="'page-link'"
                            :prev-link-class="'page-link'">
                        </paginate>
                    </div>

                </div>
            </div>
            
            

        </div>    
    </div>
</div>
</template>

<script>
import ItemConsultorio from '@/components/busca/ItemConsultorio'
import FormBusca from '@/components/busca/FormBusca'
import _ from 'lodash'

export default {
  components: {
    'busca-item-consultorio': ItemConsultorio,
    'form-busca': FormBusca
  },
  mounted () {
    window.jQuery('.filter-trigger').on('click', function () {
      window.jQuery('.filters-mobile').slideToggle(200, 'swing')
      return false
    })
  },
  computed: {
    result () {
      return this.$store.getters.result
    },
    listData () {
      return this.$store.getters.result.data
    },
    formBusca () {
      return this.$store.getters.formBusca
    },

    outrosServicosPorTipo () {
      if (this.$store.getters.formBusca.tipoPedido === 'Consulta') {
        return this.outrosServicos['especialidade']
      } else if (this.$store.getters.formBusca.tipoPedido === 'Exame') {
        return this.outrosServicos['exame']
      }

      return []
    }
  },
  data () {
    return {
      page: 1,
      preco: null,
      outroServico: {
        'Agendamento': false,
        'Delivery': false,
        'Pagamento Online': false,
        'Pagamento Ato': false,
        'Coleta em Domicílio': false
      },
      filtroPreco: [
        {vlInicial: 0, vlFinal: 60},
        {vlInicial: 60, vlFinal: 100},
        {vlInicial: 100, vlFinal: 200},
        {vlInicial: 200, vlFinal: 400},
        {vlInicial: 400, vlFinal: Number.POSITIVE_INFINITY}
      ],
      outrosServicos: {
        'especialidade': [
          'Agendamento', 'Delivery', 'Pagamento Online', 'Pagamento Ato'
        ],
        'exame': [
          'Agendamento', 'Coleta em Domicílio', 'Pagamento Online', 'Pagamento Ato'
        ]
      },
      expand: false
    }
  },
  methods: {
    buscaByRate (rate) {
      this.$store.dispatch('busca')
    },
    findByServicos () {
      this.formBusca.servicoAgendamento = this.outroServico['Agendamento']
      this.formBusca.servicoDelivery = this.outroServico['Delivery']
      this.formBusca.pagamentoOnline = this.outroServico['Pagamento Online']
      this.formBusca.pagamentoAto = this.outroServico['Pagamento Ato']
      this.formBusca.coletaDomicilio = this.outroServico['Coleta em Domicílio']
      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    },
    buscaByName () {
      this.onBuscaByName(this)
    },
    onBuscaByName: _.debounce((vm) => {
      vm.$store.dispatch('busca')
    }, 350),
    buscaByPreco () {
      let preco = this.filtroPreco[this.preco]
      this.formBusca.valorInicial = preco.vlInicial || 0
      this.formBusca.valorFinal = preco.vlFinal

      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    },

    handlePage (pageNum) {
      this.page = pageNum
      this.formBusca.page = pageNum
      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    },

    limparAvaliacao () {
      this.formBusca.rate = null
      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    },

    limparPreco () {
      this.preco = null
      this.formBusca.valorInicial = null
      this.formBusca.valorFinal = null
      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    },
    limparNome () {
      this.formBusca.nomeRede = null
      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    },
    limparOutros () {
      this.outroServico = {
        'Agendamento': false,
        'Delivery': false,
        'Pagamento Online': false,
        'Pagamento Ato': false,
        'Coleta em Domicílio': false
      }

      this.formBusca.servicoAgendamento = this.outroServico['Agendamento']
      this.formBusca.servicoDelivery = this.outroServico['Delivery']
      this.formBusca.pagamentoOnline = this.outroServico['Pagamento Online']
      this.formBusca.pagamentoAto = this.outroServico['Pagamento Ato']
      this.formBusca.coletaDomicilio = this.outroServico['Coleta em Domicílio']
      this.$store.dispatch('setFormBusca', this.formBusca)
        .then(() => this.$store.dispatch('busca'))
    }
  }
}
</script>
<style scoped>
.list-controls {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding: 10px 20px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #ffffff;
}
.list-info {
    color: rgba(0, 0, 0, 0.4);
    font-size: 0.72rem;
    text-transform: uppercase;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: 0.72rem;
}

.list-order {
    margin-left: auto;
}

</style>




// WEBPACK FOOTER //
// src/components/busca/Busca.vue